export var I18nCorpName = function (corpInfo) {
    var _a;
    if (((_a = window === null || window === void 0 ? void 0 : window.i18n) === null || _a === void 0 ? void 0 : _a.currentLocale) === 'en-US' && corpInfo.enName) {
        return corpInfo.enName;
    }
    return corpInfo.name;
};
